module.exports = __webpack_public_path__ + "img/back_blue_01.4e2b9c32.jpg";